//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import preview from '@/components/preview.vue';
import avatar from '@/components/avatar.vue';
import { setting_obj } from '@/settings/setting';
import { needXssKeys, isMobile } from '@/utils/constants';
import { handlePraise } from '@/utils/userTools';
import { diffTime, replaceToOriginStr, formatPath, isReport } from '@/utils/tools';
import statusContent from '@/components/card/status.vue';
import { activity_api } from '@/api/api/user';
import { openReport } from '@/utils/report';
import reportTip from '@/components/card/report-tip.vue';

let isClick = false;
let resourcePageInitTime = new Date().getTime();

export default {
  components: {
    preview,
    avatar,
    statusContent,
    reportTip,
  },
  data() {
    return {
      copyUrl: '',
      activityObj: {},
      resourceInfo: {},
      iframeObj: {
        fileUrl: '',
        coverUrl: '',
        width: '',
        height: '',
        border: '8px',
        showZoomButton: true,
        showProgressBar: false,
      },
      likeList: [],
      labels: ['Button', '设计系统', 'Ant', 'Antd', 'Components', 'Design System', '组件库', '组件'],
      isSelf: false,
      err: null,
    };
  },

  async asyncData({ app, query, redirect }) {
    const { act_id, res_id } = query;
    if (!act_id || !res_id) {
      return {};
    }

    try {
      const { data } = await app.$axios.$get(activity_api.works_detail, {
        params: {
          act_id,
          res_id,
        },
      });
      const res2 = await app.$axios.$get(activity_api.works_in_act, {
        params: {
          res_id,
        },
      });
      const activityObj = res2.data || {};
      const resourceInfo = data;
      app.head.title = replaceToOriginStr(`${data.res_name}-MasterGo 社区`);
      return {
        resourceInfo,
        activityObj,
        err: 'success',
      };
    } catch (e) {
      console.log('err', e);
      if (e.response.status === 404) return redirect('/404/activity-res');
      return { err: e };
    }
  },
  computed: {
    updateTime() {
      const time = this.resourceInfo.update_time;
      return time ? diffTime(new Date(time).getTime()) : '暂无时间';
    },

    activity_result() {
      const info = { ...this.activityObj };
      if (info.act_id !== undefined) {
        info.start_time = info.start_time.split('T')[0].replace(/-/g, '.');
        info.end_time = info.end_time.split('T')[0].replace(/-/g, '.');
        info.time_mark = `${info.start_time}-${info.end_time}`;
        info.act_status += '';
      }

      return info;
    },
  },
  beforeCreate() {
    resourcePageInitTime = new Date().getTime();
  },
  async mounted() {
    this.copyUrl = location.href;
    const { act_id, res_id } = this.$route.query;
    if (!this.resourceInfo.res_id) {
      if (!act_id || !res_id) {
        return {};
      }

      const { data } = await this.$axios.$get(activity_api.works_detail, {
        params: {
          act_id,
          res_id,
        },
      });
      const res2 = await this.$axios.$get(activity_api.works_in_act, {
        params: {
          res_id,
        },
      });
      this.activityObj = res2.data || {};
      this.resourceInfo = data || {};
    }

    this.copyUrl = location.href;
    // setTimeout(() => {
    //   this.isReady = true;
    // }, 200000);
    this.formatData();
    const { from, r_index } = this.$route?.query || {};
    if (from === 'official_website') {
      const sensorParams = {
        action_position: from,
        resource_id: this.resourceInfo.res_id,
        resource_name: this.resourceInfo.res_name,
      };
      if (r_index) {
        sensorParams.action_detail = r_index;
      }
      // 根据来源增加访问社区文件埋点
      this.$sensors.track('get_resource', sensorParams);
    }

    this.$sensors.track('page_view', {
      action_position: 'resource_detail',
      resource_id: this.resourceInfo.res_id,
      resource_name: this.resourceInfo.res_name,
      action_parameter0: 'activity',
    });
    this.calcSize();
    const userInfo_id = this.$store?.state?.user?.userInfo?.id;
    let { author_id } = this.resourceInfo;
    author_id = author_id ? `${author_id}` : '';
    this.isSelf = userInfo_id === author_id;

    return true;
  },
  destroyed() {
    window.onresize = null;
  },
  methods: {
    toShare() {
      this.$sensors.track('event_click', {
        action_position: 'community',
        action_parameter0: 'community_active',
        action_detail: `share`,
        action_type: 'click',
        active_id: this.activityObj.act_id,
        active_name: this.activityObj.act_name,
        resource_id: this.resourceInfo.res_id,
        resource_name: this.resourceInfo.res_name,
      });
    },
    onCopy() {
      this.$message({
        message: '分享链接已复制，快去分享吧...',
        type: 'success',
      });
    },
    onError() {
      this.$message({
        message: '分享链接复制失败,请手动复制地址栏链接',
        type: 'error',
      });
    },
    async report() {
      const { res_id } = this.$route.query;

      const is_report_value = await isReport({ res_id });
      if (is_report_value) {
        return false;
      }

      openReport('report', { res_id, res_type: 1 });
      return true;
    },
    to_activity() {
      const routeData = this.$router.resolve({
        path: '/activity/detail',
        query: {
          id: this.activityObj.act_id,
        },
      });
      location.href = routeData.href;
      // window.open(routeData.href, '_blank');
      // this.$router.push({
      //   path: '/activity',
      //   query: {
      //     id: this.activityObj.act_id,
      //   },
      // });
    },
    formatData() {
      if (!this.resourceInfo) return;
      const data = { ...this.resourceInfo };
      const allKeys = Object.keys(data);
      const keys = allKeys.filter((key) => needXssKeys.includes(key));
      keys.forEach((key) => {
        if (!data[key]) return;
        if (Array.isArray(data[key])) {
          this.resourceInfo[key] = data[key].map(replaceToOriginStr);
        } else if (typeof data[key] === 'string') {
          this.resourceInfo[key] = replaceToOriginStr(data[key]);
        }
      });
      const pathObj = {
        0: setting_obj.filePreviewPath,
        1: setting_obj.protoPath,
      };
      const { file_key, cover_url } = this.resourceInfo;
      const coverPath = formatPath(cover_url, setting_obj.imageCdnPath);
      const fileUrl = formatPath(file_key, pathObj[this.resourceInfo.display_mode]);
      this.iframeObj = {
        fileUrl: isMobile() ? '' : fileUrl,
        coverUrl: coverPath,
        width: '',
        height: '',
        border: '8px',
        showZoomButton: true,
        showProgressBar: !isMobile(),
      };
    },
    calcSize() {
      this.initSize();
      window.onresize = () => {
        this.initSize();
      };
    },
    initSize() {
      const el = this.$refs.preview;
      if (!el) return;
      const width = el.offsetWidth;
      const height = width * (9 / 16);
      el.style.height = `${height}px`;
      this.iframeObj.width = `${width}px`;
      this.iframeObj.height = `${height}px`;
    },
    like() {
      let res_id = this.$route.query.res_id;
      res_id = Number(res_id);
      if (!res_id || isClick) return;
      isClick = true;
      handlePraise({ res_id, res_type: 2, action_type: this.resourceInfo.favorite ? 2 : 1 })
        .then(() => {
          const { res_name, favorite } = this.resourceInfo;
          this.resourceInfo.favorite = !favorite;
          this.$sensors.track('like_resource', {
            action_type: this.resourceInfo.favorite ? 'like' : 'unlike',
            resource_id: res_id,
            resource_name: res_name,
          });
          if (this.resourceInfo.favorite) {
            this.resourceInfo.like_cnt++;
          } else {
            this.resourceInfo.like_cnt--;
          }
          isClick = false;
        })
        .catch(() => {
          isClick = false;
        });
    },
    goUser() {
      const routeData = this.$router.resolve({ name: 'profile-id', params: { id: this.resourceInfo.author_id } });
      window.open(routeData.href, '_blank', 'noopener,noreferrer');
    },
    handlePageTimeLog(mgCanvasReadyTime, iframeFinishedTime, layerSize) {
      if (!mgCanvasReadyTime || !iframeFinishedTime) return;
      const pageOpenToIframed = mgCanvasReadyTime - resourcePageInitTime;

      this.$sensors.track('community_iframe_load', {
        action_position: 'activity',
        resource_id: this.resourceInfo.res_id,
        resource_name: this.resourceInfo.res_name,
        action_parameter0: pageOpenToIframed,
        action_parameter1: iframeFinishedTime,
        action_parameter5: layerSize,
      });
    },
  },
};
